import { Modal } from '@/components/ui/modal'
import { useRemoveAdminUser } from '@/hooks/use-admin-users'
import type { AdminUserRecord } from '@/lib/types'

interface RemoveAdminModalProps {
  user: AdminUserRecord | null
  onClose: () => void
}

export function RemoveAdminModal({
  user,
  onClose,
}: RemoveAdminModalProps): React.JSX.Element | null {
  const removeAdmin = useRemoveAdminUser()

  if (!user) return null

  function handleConfirm(): void {
    if (!user) return
    removeAdmin.mutate(user.id, { onSuccess: onClose })
  }

  return (
    <Modal open onClose={onClose} title="Remove Admin User" size="sm">
      <div className="space-y-4">
        <p className="text-sm text-text-primary">
          Remove <span className="font-semibold">{user.email}</span>? They will lose all admin
          access immediately.
        </p>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg px-4 py-2 text-sm font-medium text-text-secondary hover:bg-surface-2"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={removeAdmin.isPending}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50"
          >
            {removeAdmin.isPending ? 'Removing...' : 'Remove Admin'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
